export function toSwapped<T>(data: T[], from: number, to: number): T[] {
  if (from === to) return data;
  return data.map((value, index, arr) => {
    if (index === from) {
      return arr[to];
    } else if (index === to) {
      return arr[from];
    } else {
      return value;
    }
  });
}

/**
 * Moves an element from one place in the array to another.
 * If the element moves upwards then all items along the way move one spot down.
 * If the element moves downwards then all items along the way will move one spot up.
 *
 * @param data
 * @param from
 * @param to
 */
export function toMoved<T>(data: T[], from: number, to: number) {
  if (from === to) return data;

  const removed = data[from];
  return data.toSpliced(from, 1).toSpliced(to, 0, removed);
}
